export default __webpack_public_path__ + "static/media/INFORM.53c4fb84.png";